import { Link, useParams, Navigate } from 'react-router-dom';
import { obterSessao } from '../services/usuarios';
import PortalCapturaNfe from './PortalCapturaNfe';
import './PortalCliente.css';

const sistemasInfo = {
  'emissao-nfe': {
    titulo: 'Emissão NFe',
    descricao: 'Automação e acompanhamento da emissão de notas fiscais eletrônicas.',
    status: 'Ativo',
  },
  'captura-nfe-sefaz': {
    titulo: 'Captura de NFe no SEFAZ',
    descricao: 'Robô que captura automaticamente as notas fiscais emitidas contra o CNPJ da empresa.',
    status: 'Ativo',
  },
  'processamento-curriculos': {
    titulo: 'Processamento de Currículos',
    descricao: 'Leitura de e-mails, captura de currículos anexados, atualização no sistema e planilha Excel de controle.',
    status: 'Ativo',
    atividades: [
      'Leitura e análise dos e-mails recebidos.',
      'Captura e processamento dos currículos anexados.',
      'Atualização das informações no sistema.',
      'Geração e atualização de planilha em Excel para controle e acompanhamento.',
    ],
  },
  'cargos-salarios': {
    titulo: 'Sistema de Cargos e Salários',
    descricao: 'Desenvolvimento e automação da gestão de cargos e salários, com planilhas Excel de controle e análise.',
    status: 'Ativo',
    atividades: [
      'Desenvolvimento e implementação do sistema de Cargos e Salários.',
      'Automação completa dos processos relacionados ao cadastro, atualização e gestão de cargos e salários.',
      'Integração e geração de planilhas em Excel para controle, análise e acompanhamento das informações.',
    ],
  },
};

function PortalSistema() {
  const { id } = useParams();
  const sessao = obterSessao();
  const sistema = sistemasInfo[id];

  if (!sessao?.token) {
    return <Navigate to="/portal" replace />;
  }

  if (id === 'captura-nfe-sefaz') {
    return <PortalCapturaNfe />;
  }

  if (!sistema) {
    return (
      <div className="portal-page">
        <div className="page-hero">
          <h1>Sistema não encontrado</h1>
          <p>O sistema solicitado não está disponível.</p>
        </div>
        <section className="section">
          <div className="container" style={{ textAlign: 'center' }}>
            <Link to="/portal" className="btn btn-outline">Voltar aos sistemas</Link>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="portal-page">
      <div className="page-hero">
        <h1>{sistema.titulo}</h1>
        <p>{sistema.descricao}</p>
      </div>

      <section className="section">
        <div className="container">
          <div className="portal-projeto-detail">
            <span className="portal-projeto-status">{sistema.status}</span>
            <h2>Sobre o sistema</h2>

            {sistema.atividades?.length ? (
              <>
                <h3 className="portal-atividades-title">Funcionalidades</h3>
                <ul className="portal-atividades-list">
                  {sistema.atividades.map((atividade) => (
                    <li key={atividade}>{atividade}</li>
                  ))}
                </ul>
              </>
            ) : (
              <p>
                Em breve você poderá utilizar aqui as funcionalidades deste sistema.
              </p>
            )}

            <Link to="/portal" className="btn btn-outline">← Voltar aos sistemas</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PortalSistema;
